import { Copy, Download, Printer } from 'lucide-react'

import { Button } from '@/shared/ui/primitives'

export type QrPreviewProps = {
  title: string
  description: string
  publicUrl: string
  imageDataUrl: string
  onCopyUrl: () => void
  onDownload: () => void
  onPrint: () => void
}

export function QrPreview({
  title,
  description,
  publicUrl,
  imageDataUrl,
  onCopyUrl,
  onDownload,
  onPrint,
}: QrPreviewProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
      <div className="flex size-40 shrink-0 items-center justify-center overflow-hidden rounded-lg border bg-white p-2">
        {imageDataUrl ? (
          <img
            src={imageDataUrl}
            alt={`QR code for ${title}`}
            className="size-full object-contain"
          />
        ) : null}
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-3">
        <div className="min-w-0">
          <h4 className="font-display text-sm font-semibold">{title}</h4>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>

        <code className="block overflow-x-auto rounded-md border bg-muted/40 px-3 py-2 font-mono text-xs">
          {publicUrl}
        </code>

        <div className="flex flex-wrap items-center gap-2">
          <Button type="button" variant="outline" onClick={onCopyUrl}>
            <Copy className="size-4" />
            Copy link
          </Button>
          <Button type="button" variant="outline" onClick={onPrint}>
            <Printer className="size-4" />
            Print
          </Button>
          <Button type="button" onClick={onDownload}>
            <Download className="size-4" />
            Download PNG
          </Button>
        </div>
      </div>
    </div>
  )
}
